module.exports = __webpack_public_path__ + "static/media/elephant.3a37c8b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/ware-2018/elephant.mp3
// module id = E8Dc
// module chunks = 0